var map = {
	"./BungkusIT.png": "5c4c8",
	"./Grab Express.png": "2f46",
	"./HaloExpress.png": "db80",
	"./Lalamove.png": "8f49",
	"./MatDespatch.png": "6ee7",
	"./MrSpeedy.png": "8c68",
	"./Zepto.png": "8111",
	"./pickupp.png": "b715"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54e4";